'use strict';
const px = require('@mindmup/mapjs-core/src/util/px');
module.exports = function updateNodeIcon(nodeView, nodeDOM) {
	if (!nodeView || !nodeDOM) {
		throw new Error('invalid-args');
	}
	const nodeMetrics = nodeView.metrics;
	if (!nodeMetrics.icon) {
		nodeDOM.style.backgroundImage = '';
	} else {
		nodeDOM.style.backgroundImage = `url("${nodeView.icon.url}")`;
		nodeDOM.style.backgroundRepeat = 'no-repeat';
		nodeDOM.style.backgroundSize = `${px(nodeMetrics.icon.width)} ${px(nodeMetrics.icon.height)}`;
		if (nodeMetrics.text) {
			const iconRelativeToBubbleY = nodeMetrics.icon.y - nodeMetrics.bubble.border - nodeMetrics.bubble.y,
				iconRelativeToBubbleX = nodeMetrics.icon.x - nodeMetrics.bubble.border - nodeMetrics.bubble.x;
			nodeDOM.style.backgroundPosition = `${px(iconRelativeToBubbleX)} ${px(iconRelativeToBubbleY)}`;
		} else {
			nodeDOM.style.backgroundPosition = 'center center';
		}
	}
};
